/*
 * @Author: 张天昊
 * @Date: 2024-11-15 14:04:54
 * @LastEditTime: 2024-11-15 14:24:03
 * @LastEditors: 张天昊
 * @Description: 隐私政策协议相关接口
 * @FilePath: /Mobile/src/service/modules/privacy.js
 */
import $http from '../../utils/http';

export function getPrivacyCollectionInfo(data) {
  return $http({
    url: '/gov/v2/tio/system/privacy/details',
    method: 'GET',
    params: data,
    baseURL: process.env.VUE_APP_BASE_URL
  });
}
